<template>
  <span>
  <template v-if="status === 'Pending'"> <span class="pending-text"> {{ $t(status)}} </span></template>
  <template v-if="status === 'Acknowledged'"> <span class="acknowledge-text"> {{ $t(status)}} </span></template>
  <template v-if="status === 'Preparing'"> <span class="preparing-text"> {{ $t(status)}} </span></template>
  <template v-if="status === 'Delivering'"> <span class="delivery-text"> {{ $t(status)}} </span></template>
  <template v-if="status === 'Done'"> <span class="completed-text"> {{ $t(status)}} </span></template>
  </span>

</template>
<script>
export default {
  name: "status_text_sale",
  props:{
    status: String
  }
};
</script>